import "./firebase/firebaseConfig"; // Import firebaseConfig to initialize Firebase
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getUserRole } from "./firebase/userService"; // Import getUserRole function
import Login from "./pages/Login";
import PublicHome from "./pages/PublicHome";
import Checkout from "./pages/Checkout";
import ProductsPage from "./catalog/ProductsPage";
import OrderConfirmation from "./pages/OrderConfirmation";
import Unauthorized from "./pages/Unauthorized";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsers from "./pages/AdminUsers";
import AdminTools from "./pages/AdminTools";
import AdminRoles from "./pages/AdminRoles";
import AdminSettings from "./pages/AdminSettings";
import AdminCatalogPage from "./admin/productCatalog/AdminCatalogPage";
import DashboardEducator from "./pages/DashboardEducator";
import Dashboard from "./pages/Dashboard";
import ParentReport from "./pages/ParentReport";
import AdminEmails from "./pages/AdminEmails";
// 5/2/2026 Imports to for layout builder
import LayoutBuilder from "./pages/builder/LayoutBuilder";
import DynamicPortalPage from "./pages/builder/DynamicPortalPage";
import AdminSchools from "./admin/schools/AdminSchools";

import DynamicTreasureMapPage from "./pages/builder/DynamicTreasureMapPage";

import PrivateRoute from "./components/PrivateRoute";
import PageWrapper from "./components/PageWrapper";
import DynamicPage from "./pages/DynamicPage";
import DynamicClassroom from "./pages/DynamicClassroom"; // Import DynamicClassroom component
import DashboardEducatorThanks from './pages/DashboardEducatorThanks';
import CustomContent from './pages/CustomContent';
// import Scheduler from './pages/scheduler';
import usePageTracking from "./hooks/usePageTracking";
import AdminBulkUpload from "./pages/admin/AdminBulkUpload";
import UpgradeEducator from "./pages/UpgradeEducator";
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";
import AccountSettings from "./pages/AccountSettings";
import CoinsThanks from "./pages/CoinsThanks";
import ChoosePlan from "./pages/ChoosePlan";
import UpgradeSuccess from "./pages/UpgradeSuccess";
import ManageSeats from "./pages/ManageSeats";
import ClaimSeat from "./pages/ClaimSeat";
import PurchaseOrderRequest from "./pages/PurchaseOrderRequest";
import PurchaseOrders from "./pages/PurchaseOrders";
import GameLab from "./pages/admin/GameLab";

// North Carolina Imports for Educators
import Nc1stEducatorMath from "./pages/educator/nc/nc-1st-educator-math";
import Nc1stEducatorScience from "./pages/educator/nc/nc-1st-educator-science";
import Nc1stEducatorSocialStudies from "./pages/educator/nc/nc-1st-educator-socialstudies";
import Nc1stEducatorOther from "./pages/educator/nc/nc-1st-educator-other";
import Nc1stEducatorClassroom from "./pages/educator/nc/nc-1st-educator-classroom"; // Ensure correct import
import Nc2ndEducatorClassroom from "./pages/educator/nc/nc-2nd-educator-classroom";
import Nc3rdEducatorClassroom from "./pages/educator/nc/nc-3rd-educator-classroom";
import Nc4thEducatorClassroom from "./pages/educator/nc/nc-4th-educator-classroom";
import Nc5thEducatorClassroom from "./pages/educator/nc/nc-5th-educator-classroom";
import Nc2ndEducatorMath from "./pages/educator/nc/nc-2nd-educator-math";
import Nc2ndEducatorScience from "./pages/educator/nc/nc-2nd-educator-science";
import Nc2ndEducatorSocialStudies from "./pages/educator/nc/nc-2nd-educator-socialstudies";
import Nc2ndEducatorOther from "./pages/educator/nc/nc-2nd-educator-other";
import Nc3rdEducatorMath from "./pages/educator/nc/nc-3rd-educator-math";
import Nc3rdEducatorScience from "./pages/educator/nc/nc-3rd-educator-science";
import Nc3rdEducatorSocialStudies from "./pages/educator/nc/nc-3rd-educator-socialstudies";
import Nc3rdEducatorOther from "./pages/educator/nc/nc-3rd-educator-other";
import Nc4thEducatorMath from "./pages/educator/nc/nc-4th-educator-math";
import Nc4thEducatorScience from "./pages/educator/nc/nc-4th-educator-science";
import Nc4thEducatorSocialStudies from "./pages/educator/nc/nc-4th-educator-socialstudies";
import Nc4thEducatorOther from "./pages/educator/nc/nc-4th-educator-other";
import Nc5thEducatorMath from "./pages/educator/nc/nc-5th-educator-math";
import Nc5thEducatorScience from "./pages/educator/nc/nc-5th-educator-science";
import Nc5thEducatorSocialStudies from "./pages/educator/nc/nc-5th-educator-socialstudies";
import Nc5thEducatorOther from "./pages/educator/nc/nc-5th-educator-other";

// North Carolina Imports for Students
import Nc1stStudentMath from "./pages/student/nc/nc-1st-student-math";
import Nc1stStudentScience from "./pages/student/nc/nc-1st-student-science";
import Nc1stStudentSocialStudies from "./pages/student/nc/nc-1st-student-socialstudies";
import Nc1stStudentOther from "./pages/student/nc/nc-1st-student-other";
import Nc2ndStudentMath from "./pages/student/nc/nc-2nd-student-math";
import Nc2ndStudentScience from "./pages/student/nc/nc-2nd-student-science";
import Nc2ndStudentSocialStudies from "./pages/student/nc/nc-2nd-student-socialstudies";
import Nc2ndStudentOther from "./pages/student/nc/nc-2nd-student-other";
import Nc3rdStudentMath from "./pages/student/nc/nc-3rd-student-math";
import Nc3rdStudentScience from "./pages/student/nc/nc-3rd-student-science";
import Nc3rdStudentSocialStudies from "./pages/student/nc/nc-3rd-student-socialstudies";
import Nc3rdStudentOther from "./pages/student/nc/nc-3rd-student-other";
import Nc4thStudentMath from "./pages/student/nc/nc-4th-student-math";
import Nc4thStudentScience from "./pages/student/nc/nc-4th-student-science";
import Nc4thStudentSocialStudies from "./pages/student/nc/nc-4th-student-socialstudies";
import Nc4thStudentOther from "./pages/student/nc/nc-4th-student-other";
import Nc5thStudentMath from "./pages/student/nc/nc-5th-student-math";
import Nc5thStudentScience from "./pages/student/nc/nc-5th-student-science";
import Nc5thStudentSocialStudies from "./pages/student/nc/nc-5th-student-socialstudies";
import Nc5thStudentOther from "./pages/student/nc/nc-5th-student-other";

// Add import of combinations from AdminTools then route it then div i with const in that specific page your trying to show


import AllEducatorOther from "./pages/educator/all-all-educator-other";
import AllEducatorMath from "./pages/educator/all-all-educator-math";
import AllEducatorScience from "./pages/educator/all-all-educator-science";
import AllEducatorSocialStudies from "./pages/educator/all-all-educator-socialstudies";
import Classroom1st from "./pages/educator/Classroom1st";
import Classroom2nd from "./pages/educator/Classroom2nd";
import Classroom3rd from "./pages/educator/Classroom3rd";
import Classroom4th from "./pages/educator/Classroom4th";
import Classroom5th from "./pages/educator/Classroom5th";
import AdminClassroom from "./pages/AdminClassroom";
import SlideShow from "./pages/SlideShow"; // Corrected path
import SlideUploader from "./pages/SlideUploader"; // Corrected path
import SyncEditor from "./pages/SyncEditor"; // Corrected path
import EditSlideShow from './pages/educator/EditSlideShow';

import GameLoader from "./games/GameLoader"; // Import GameLoader component
import UniversalQuizGame from "./games/UniversalQuizGame";
import QuizUploader from "./components/QuizUploader";
import QuizManager from "./components/QuizManager";
import TermsOfService from "./pages/legal/TermsOfService";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import EducatorClassroom from "./pages/educator/EducatorClassroom";
import LegacyClassroomRedirect from "./pages/educator/LegacyClassroomRedirect";
import EducatorQuizEditor from "./pages/educator/EducatorQuizEditor";
import AdminQuizReview from "./pages/admin/AdminQuizReview";
import Leaderboard from "./components/Leaderboard";
import AdminLeaderboards from "./components/admin/AdminLeaderboards";

// Virginia Imports for Educators
import Va1stEducatorSocialStudies from "./pages/educator/va/va-1st-educator-socialstudies";
import Va3rdEducatorSocialStudies from "./pages/educator/va/va-3rd-educator-socialstudies";
import Va2ndEducatorSocialStudies from "./pages/educator/va/va-2nd-educator-socialstudies";
import Va4thEducatorSocialStudies from "./pages/educator/va/va-4th-educator-socialstudies";
import Va5thEducatorSocialStudies from "./pages/educator/va/va-5th-educator-socialstudies";
import Va1stEducatorScience from "./pages/educator/va/va-1st-educator-science";
import Va3rdEducatorScience from "./pages/educator/va/va-3rd-educator-science";
import Va2ndEducatorScience from "./pages/educator/va/va-2nd-educator-science";
import Va4thEducatorScience from "./pages/educator/va/va-4th-educator-science";
import Va5thEducatorScience from "./pages/educator/va/va-5th-educator-science";
import Va1stEducatorMath from "./pages/educator/va/va-1st-educator-math";
import Va3rdEducatorMath from "./pages/educator/va/va-3rd-educator-math";
import Va2ndEducatorMath from "./pages/educator/va/va-2nd-educator-math";
import Va4thEducatorMath from "./pages/educator/va/va-4th-educator-math";
import Va5thEducatorMath from "./pages/educator/va/va-5th-educator-math";
import Va1stEducatorOther from "./pages/educator/va/va-1st-educator-other";
import Va3rdEducatorOther from "./pages/educator/va/va-3rd-educator-other";
import Va2ndEducatorOther from "./pages/educator/va/va-2nd-educator-other";
import Va4thEducatorOther from "./pages/educator/va/va-4th-educator-other";
import Va5thEducatorOther from "./pages/educator/va/va-5th-educator-other";
import Va1stEducatorClassroom from "./pages/educator/va/va-1st-educator-classroom";
import Va2ndEducatorClassroom from "./pages/educator/va/va-2nd-educator-classroom";
import Va3rdEducatorClassroom from "./pages/educator/va/va-3rd-educator-classroom";
import Va4thEducatorClassroom from "./pages/educator/va/va-4th-educator-classroom";
import Va5thEducatorClassroom from "./pages/educator/va/va-5th-educator-classroom";

// Virginia Imports for Students
import Va1stStudentSocialStudies from "./pages/student/va/va-1st-student-socialstudies";
import Va3rdStudentSocialStudies from "./pages/student/va/va-3rd-student-socialstudies";
import Va2ndStudentSocialStudies from "./pages/student/va/va-2nd-student-socialstudies";
import Va4thStudentSocialStudies from "./pages/student/va/va-4th-student-socialstudies";
import Va5thStudentSocialStudies from "./pages/student/va/va-5th-student-socialstudies";
import Va1stStudentScience from "./pages/student/va/va-1st-student-science";
import Va3rdStudentScience from "./pages/student/va/va-3rd-student-science";
import Va2ndStudentScience from "./pages/student/va/va-2nd-student-science";
import Va4thStudentScience from "./pages/student/va/va-4th-student-science";
import Va5thStudentScience from "./pages/student/va/va-5th-student-science";
import Va1stStudentMath from "./pages/student/va/va-1st-student-math";
import Va3rdStudentMath from "./pages/student/va/va-3rd-student-math";
import Va2ndStudentMath from "./pages/student/va/va-2nd-student-math";
import Va4thStudentMath from "./pages/student/va/va-4th-student-math";
import Va5thStudentMath from "./pages/student/va/va-5th-student-math";
import Va1stStudentOther from "./pages/student/va/va-1st-student-other";
import Va3rdStudentOther from "./pages/student/va/va-3rd-student-other";
import Va2ndStudentOther from "./pages/student/va/va-2nd-student-other";
import Va4thStudentOther from "./pages/student/va/va-4th-student-other";
import Va5thStudentOther from "./pages/student/va/va-5th-student-other";

// Georgia Imports for Educators
import Ga1stEducatorSocialStudies from "./pages/educator/ga/ga-1st-educator-socialstudies";
import Ga2ndEducatorSocialStudies from "./pages/educator/ga/ga-2nd-educator-socialstudies";
import Ga3rdEducatorSocialStudies from "./pages/educator/ga/ga-3rd-educator-socialstudies";
import Ga4thEducatorSocialStudies from "./pages/educator/ga/ga-4th-educator-socialstudies";
import Ga5thEducatorSocialStudies from "./pages/educator/ga/ga-5th-educator-socialstudies";
import Ga1stEducatorScience from "./pages/educator/ga/ga-1st-educator-science";
import Ga2ndEducatorScience from "./pages/educator/ga/ga-2nd-educator-science";
import Ga3rdEducatorScience from "./pages/educator/ga/ga-3rd-educator-science";
import Ga4thEducatorScience from "./pages/educator/ga/ga-4th-educator-science";
import Ga5thEducatorScience from "./pages/educator/ga/ga-5th-educator-science";
import Ga1stEducatorMath from "./pages/educator/ga/ga-1st-educator-math";
import Ga2ndEducatorMath from "./pages/educator/ga/ga-2nd-educator-math";
import Ga3rdEducatorMath from "./pages/educator/ga/ga-3rd-educator-math";
import Ga4thEducatorMath from "./pages/educator/ga/ga-4th-educator-math";
import Ga5thEducatorMath from "./pages/educator/ga/ga-5th-educator-math";
import Ga1stEducatorOther from "./pages/educator/ga/ga-1st-educator-other";
import Ga2ndEducatorOther from "./pages/educator/ga/ga-2nd-educator-other";
import Ga3rdEducatorOther from "./pages/educator/ga/ga-3rd-educator-other";
import Ga4thEducatorOther from "./pages/educator/ga/ga-4th-educator-other";
import Ga5thEducatorOther from "./pages/educator/ga/ga-5th-educator-other";
import Ga1stEducatorClassroom from "./pages/educator/ga/ga-1st-educator-classroom";
import Ga2ndEducatorClassroom from "./pages/educator/ga/ga-2nd-educator-classroom";
import Ga3rdEducatorClassroom from "./pages/educator/ga/ga-3rd-educator-classroom";
import Ga4thEducatorClassroom from "./pages/educator/ga/ga-4th-educator-classroom";
import Ga5thEducatorClassroom from "./pages/educator/ga/ga-5th-educator-classroom";

// California Imports for Educators
import Ca1stEducatorSocialStudies from "./pages/educator/ca/ca-1st-educator-socialstudies";
import Ca2ndEducatorSocialStudies from "./pages/educator/ca/ca-2nd-educator-socialstudies";
import Ca3rdEducatorSocialStudies from "./pages/educator/ca/ca-3rd-educator-socialstudies";
import Ca4thEducatorSocialStudies from "./pages/educator/ca/ca-4th-educator-socialstudies";
import Ca5thEducatorSocialStudies from "./pages/educator/ca/ca-5th-educator-socialstudies";
import Ca1stEducatorScience from "./pages/educator/ca/ca-1st-educator-science";
import Ca2ndEducatorScience from "./pages/educator/ca/ca-2nd-educator-science";
import Ca3rdEducatorScience from "./pages/educator/ca/ca-3rd-educator-science";
import Ca4thEducatorScience from "./pages/educator/ca/ca-4th-educator-science";
import Ca5thEducatorScience from "./pages/educator/ca/ca-5th-educator-science";
import Ca1stEducatorMath from "./pages/educator/ca/ca-1st-educator-math";
import Ca2ndEducatorMath from "./pages/educator/ca/ca-2nd-educator-math";
import Ca3rdEducatorMath from "./pages/educator/ca/ca-3rd-educator-math";
import Ca4thEducatorMath from "./pages/educator/ca/ca-4th-educator-math";
import Ca5thEducatorMath from "./pages/educator/ca/ca-5th-educator-math";
import Ca1stEducatorOther from "./pages/educator/ca/ca-1st-educator-other";
import Ca2ndEducatorOther from "./pages/educator/ca/ca-2nd-educator-other";
import Ca3rdEducatorOther from "./pages/educator/ca/ca-3rd-educator-other";
import Ca4thEducatorOther from "./pages/educator/ca/ca-4th-educator-other";
import Ca5thEducatorOther from "./pages/educator/ca/ca-5th-educator-other";
import Ca1stEducatorClassroom from "./pages/educator/ca/ca-1st-educator-classroom";
import Ca2ndEducatorClassroom from "./pages/educator/ca/ca-2nd-educator-classroom";
import Ca3rdEducatorClassroom from "./pages/educator/ca/ca-3rd-educator-classroom";
import Ca4thEducatorClassroom from "./pages/educator/ca/ca-4th-educator-classroom";
import ClassroomLeaderboard from "./pages/educator/ClassroomLeaderboard";

import Ca5thEducatorClassroom from "./pages/educator/ca/ca-5th-educator-classroom";

// California Imports for Students
import Ca1stStudentSocialStudies from "./pages/student/ca/ca-1st-student-socialstudies";
import Ca2ndStudentSocialStudies from "./pages/student/ca/ca-2nd-student-socialstudies";
import Ca3rdStudentSocialStudies from "./pages/student/ca/ca-3rd-student-socialstudies";
import Ca4thStudentSocialStudies from "./pages/student/ca/ca-4th-student-socialstudies";
import Ca5thStudentSocialStudies from "./pages/student/ca/ca-5th-student-socialstudies";
import Ca1stStudentScience from "./pages/student/ca/ca-1st-student-science";
import Ca2ndStudentScience from "./pages/student/ca/ca-2nd-student-science";
import Ca3rdStudentScience from "./pages/student/ca/ca-3rd-student-science";
import Ca4thStudentScience from "./pages/student/ca/ca-4th-student-science";
import Ca5thStudentScience from "./pages/student/ca/ca-5th-student-science";
import Ca1stStudentMath from "./pages/student/ca/ca-1st-student-math";
import Ca2ndStudentMath from "./pages/student/ca/ca-2nd-student-math";
import Ca3rdStudentMath from "./pages/student/ca/ca-3rd-student-math";
import Ca4thStudentMath from "./pages/student/ca/ca-4th-student-math";
import Ca5thStudentMath from "./pages/student/ca/ca-5th-student-math";
import Ca1stStudentOther from "./pages/student/ca/ca-1st-student-other";
import Ca2ndStudentOther from "./pages/student/ca/ca-2nd-student-other";
import Ca3rdStudentOther from "./pages/student/ca/ca-3rd-student-other";
import Ca4thStudentOther from "./pages/student/ca/ca-4th-student-other";
import Ca5thStudentOther from "./pages/student/ca/ca-5th-student-other";


import MapPage from "./pages/MapPage"; // Import MapPage
import { topics } from "./data/topics"; // Import topics
import VideoTool from "./components/tools/VideoTool"; // Corrected path
import MusicTool from "./components/tools/MusicTool"; // Corrected path
import GameTool from "./components/tools/GameTool"; // Corrected path
import MarkProgress from "./utils/markProgress";
import { CartProvider } from "./cart/CartContext";

// --- START: add RouteTracker component ---
function RouteTracker() {
  usePageTracking();
  return null; // it just runs the hook; no UI
}
// --- END: add RouteTracker component ---

// Assuming size options are defined somewhere in the code, add the new ratio:
const sizeOptions = [
  // ...existing size options...
  { label: "4:3", width: 1024, height: 768 }, // Add 4:3 ratio option
];

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUserRole, setCurrentUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const STATES = ["al","ak","az","ar","ca","co","ct","de","fl","ga","hi","id","il","in","ia","ks","ky","la","me","md","ma","mi","mn","ms","mo","mt","ne","nv","nh","nj","nm","ny","nc","nd","oh","ok","or","pa","ri","sc","sd","tn","tx","ut","vt","va","wa","wv","wi","wy","dc"]; // add/remove states here once
// K-8. This single line is the grade gate for the whole app: it generates
// every student and educator role below, and PrivateRoute matches those roles
// literally. Adding "9th" here is all that a 9th grade rollout needs.
//
// Tokens must match GRADE_TOKENS in src/config/geography.js exactly —
// "k", not "K" or "Kindergarten". A casing drift here produces accounts that
// authenticate fine and then match no route, which reads as a billing bug.
const GRADES = ["k", "1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th"];
  
const allStudentRoles = STATES.flatMap(s =>
  GRADES.map(g => `${s}-${g}-student`)
);

const allEducatorRoles = STATES.flatMap(s =>
  GRADES.map(g => `${s}-${g}-educator`)
);
  
  
  // const allStudentRoles = [
  //  "nc-1st-student", "nc-2nd-student", "nc-3rd-student", "nc-4th-student", "nc-5th-student",
  //  "va-1st-student", "va-2nd-student", "va-3rd-student", "va-4th-student", "va-5th-student"
  // ];
  
 // const allEducatorRoles = [
 //   "nc-1st-educator", "nc-2nd-educator", "nc-3rd-educator", "nc-4th-educator", "nc-5th-educator",
  //  "va-1st-educator", "va-2nd-educator", "va-3rd-educator", "va-4th-educator", "va-5th-educator"
  // ];
  
  const adminRole = "administrator";
  
  useEffect(() => {
    const auth = getAuth();

    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const role = await getUserRole(user.uid); // Fetch the role from Firestore using user ID
          setCurrentUserRole(role); // Set the fetched role
          setIsAuthenticated(true);
        } catch (error) {
          console.error("Error fetching user role:", error);
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
        setCurrentUserRole(null);
      }
      setLoading(false); // Stop showing the loading spinner
    });

    return () => unsubscribe(); // Clean up the listener on unmount
  }, []);

  if (loading) {
    return <p>Loading...</p>; // Show a loading state while Firebase initializes
  }

 
  
  return (
    <Router> {/* Ensure Router wraps all routes */}
     <RouteTracker />
     <CartProvider>
      <Routes>
        {/* Login Route */}

        <Route path="/login" element={<Login />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/products" element={<ProductsPage />} />
   <Route path="/order-confirmation" element={<OrderConfirmation />} />

        {/* Sign-up -> verify -> plan -> Stripe checkout.
            These are intentionally public: the person doesn't have a role yet
            (they're "unpaid" until the webhook promotes them), so wrapping
            them in PrivateRoute would lock everyone out of the flow that
            gets them a role in the first place. Each page guards itself. */}
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/choose-plan" element={<ChoosePlan />} />
        {/* Password + subscription (cancel lives here). The page checks sign-in itself. */}
        <Route path="/account" element={<AccountSettings />} />
        {/* After paying for a coin pack (functions/coinStore.js) */}
        <Route path="/coins/thanks" element={<CoinsThanks />} />
        <Route path="/upgrade-success" element={<UpgradeSuccess />} />

        {/* Seat assignment. /claim-seat is public because the person arriving
            from an invite email may not have an account yet — the page walks
            them through sign-in or registration itself. */}
        <Route path="/claim-seat" element={<ClaimSeat />} />
        <Route
          path="/seats"
          element={
            <PrivateRoute
              currentUserRole={currentUserRole}
              requireCapability="manageSeats"
            >
              <ManageSeats />
            </PrivateRoute>
          }
        />

        {/* Unauthorized Route */}
        <Route path="/unauthorized" element={<Unauthorized />} />


        {/* Admin Users Route */}
        <Route path="/admin/users" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <AdminUsers />
  </PrivateRoute>}/>

  <Route path="/upgrade" element={<UpgradeEducator />} />

        {/* Admin Tools Route */}
        <Route path="/admin/tools" 
          element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
            <AdminTools />
          </PrivateRoute>}
        />
<Route path="/admin/settings" 
          element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
            <AdminSettings />
          </PrivateRoute>}
        />
        <Route path="/admin/products" 
          element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
            <AdminCatalogPage />
          </PrivateRoute>}
        />

<Route path="/admin/schools"
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <AdminSchools />
  </PrivateRoute>}/>

  <Route path="/admin/game-lab"
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <GameLab />
  </PrivateRoute>}/>

<Route
  path="/purchase-orders"
  element={
    <PrivateRoute
      allowedRoles={["administrator", "admin"]}
      currentUserRole={currentUserRole}
    >
      <PurchaseOrders />
    </PrivateRoute>
  }
/>

{/*  <Route path="/scheduler" 
          element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
            <Scheduler/>
          </PrivateRoute>}
        /> */}
<Route path="/purchase-order" element={<PurchaseOrderRequest />} />  

<Route
  path="/custom-content"
  element={
    <PrivateRoute
      allowedRoles={["administrator", "admin"]} // tweak as you like
      currentUserRole={currentUserRole}
    >
      <CustomContent />
    </PrivateRoute>
  }
/>

<Route path="/admin/bulk-upload" 
 element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
 <AdminBulkUpload />
</PrivateRoute>}/>


        {/* Admin Roles Route */}
        <Route path="/admin/roles" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <AdminRoles />
  </PrivateRoute>}/>
  
  <Route path="/admin/emails" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <AdminEmails />
  </PrivateRoute>}/>

  <Route path="/payment-success" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <AdminRoles />
  </PrivateRoute>}/>

        {/* Admin Settings Route */}
     

  <Route path="/educator/all-all-educator-science" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <AllEducatorScience />
  </PrivateRoute>}/>

  <Route path="/educator/all-all-educator-math" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <AllEducatorMath />
  </PrivateRoute>}/>

  <Route path="/educator/all-all-educator-other" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <AllEducatorOther />
  </PrivateRoute>}/>

  <Route path="/educator/all-all-educator-socialstudies" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <AllEducatorSocialStudies />
  </PrivateRoute>}/>

  <Route path="/educator/slideshow" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <SlideShow />
  </PrivateRoute>}/>


  <Route path="/educator/slideuploader" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <SlideUploader />
  </PrivateRoute>}/>

  <Route path="/educator/synceditor/:slideshowId" 
  element={<PrivateRoute allowedRoles={["administrator", "admin", "educator"]} currentUserRole={currentUserRole}>
    <SyncEditor />
  </PrivateRoute>}/>

  <Route path="/educator/synceditor" 
  element={<PrivateRoute allowedRoles={["administrator", "admin", "educator"]} currentUserRole={currentUserRole}>
    <SyncEditor />
  </PrivateRoute>}/>

  <Route path="/synceditor/:slideshowId" element={<SyncEditor />} /> {/* Added SyncEditor route */}

  <Route path="/slideshow/:slideshowId" element={<SlideShow />} /> {/* Critical route */}

        {/* START ALL DASHBOARDS Route */}
        {/* Admin Route */}
        <Route path="/admin" 
  element={<PrivateRoute allowedRoles={["administrator", "admin"]} currentUserRole={currentUserRole}>
    <AdminDashboard />
  </PrivateRoute>}/>
       
        {/* Educator Dashboard Route */}
        <Route path="/educator/dashboard" 
  element={<PrivateRoute allowFree allowedRoles={[
    "administrator",
    ...allEducatorRoles,
  ]
  } currentUserRole={currentUserRole}>
    <DashboardEducator />
  </PrivateRoute>}/>


        {/* General Dashboard Route */}
        {/* 👪 For grown-ups: the child's learning report */}
        <Route path="/grown-ups"
  element={<PrivateRoute allowFree allowedRoles={[
    "administrator",
    ...allStudentRoles,
  ]
  } currentUserRole={currentUserRole}>
    <ParentReport />
  </PrivateRoute>}/>

        <Route path="/dashboard" 
  element={<PrivateRoute allowFree allowedRoles={[
    "administrator",
    ...allStudentRoles,
  ]
  } currentUserRole={currentUserRole}>
    <Dashboard />
  </PrivateRoute>}/>

  {/* Educator Dashboard Thanks Route */}
<Route
  path="/educator/dashboard/thanks"
  element={<PrivateRoute allowedRoles={[
    "administrator",
    ...allEducatorRoles,
  ]
  } currentUserRole={currentUserRole}>
      <DashboardEducatorThanks />
    </PrivateRoute>}/>

        {/* END ALL DASHBOARDS Route */}

         {/* 5/2/2026 New Routes for Layout Builder*/}

         <Route
  path="/admin/layout-builder"
  element={
    <PrivateRoute
      allowedRoles={["administrator", "admin", "Administrator", "Admin"]}
      currentUserRole={currentUserRole}
    >
      <LayoutBuilder />
    </PrivateRoute>
  }
/>

<Route
  path="/portal/:state/:grade/:subject/:view"
  element={
    <PrivateRoute
      allowFree
      allowedRoles={[
        "administrator",
        "admin",
        "Administrator",
        "Admin",
        ...allStudentRoles,
        ...allEducatorRoles,
      ]}
      currentUserRole={currentUserRole}
    >
      <DynamicPortalPage />
    </PrivateRoute>
  }
/>

<Route
  path="/dynamic-treasure-map/:state/:grade/:subject/:view/:targetSlug"
  element={
    <PrivateRoute
      allowFree
      allowedRoles={[
        "administrator",
        "admin",
        "Administrator",
        "Admin",
        ...allStudentRoles,
        ...allEducatorRoles,
      ]}
      currentUserRole={currentUserRole}
    >
      <DynamicTreasureMapPage />
    </PrivateRoute>
  }
/>

        {/* Educator Pages Routes */}

        <Route
  path="/educator/leaderboard/:subject?"
  element={
    <PrivateRoute
      allowFree
      allowedRoles={["educator", "administrator", "admin"]}
      currentUserRole={currentUserRole}
    >
      <ClassroomLeaderboard />
    </PrivateRoute>
  }
/>
        <Route path="/educator/nc/nc-1st-educator-math" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-1st-educator"]} currentUserRole={currentUserRole}>
    <Nc1stEducatorMath />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-1st-educator-science" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-1st-educator"]} currentUserRole={currentUserRole}>
    <Nc1stEducatorScience />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-1st-educator-socialstudies" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-1st-educator"]} currentUserRole={currentUserRole}>
    <Nc1stEducatorSocialStudies />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-1st-educator-other" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-1st-educator"]} currentUserRole={currentUserRole}>
    <Nc1stEducatorOther />
  </PrivateRoute>}/>

  <Route path="/educator/nc/nc-1st-educator-classroom" 
  element={<PrivateRoute allowFree allowedRoles={["administrator", "nc-1st-educator"]} currentUserRole={currentUserRole}>
    <Nc1stEducatorClassroom />
  </PrivateRoute>}/>

  <Route path="/educator/nc/nc-2nd-educator-classroom" 
  element={<PrivateRoute allowFree allowedRoles={["administrator", "nc-2nd-educator"]} currentUserRole={currentUserRole}>
    <Nc2ndEducatorClassroom />
  </PrivateRoute>}/>

  <Route path="/educator/nc/nc-3rd-educator-classroom" 
  element={<PrivateRoute allowFree allowedRoles={["administrator", "nc-3rd-educator"]} currentUserRole={currentUserRole}>
    <Nc3rdEducatorClassroom />
  </PrivateRoute>}/>

  <Route path="/educator/nc/nc-4th-educator-classroom" 
  element={<PrivateRoute allowFree allowedRoles={["administrator", "nc-4th-educator"]} currentUserRole={currentUserRole}>
    <Nc4thEducatorClassroom />
  </PrivateRoute>}/>

  <Route path="/educator/nc/nc-5th-educator-classroom" 
  element={<PrivateRoute allowFree allowedRoles={["administrator", "nc-5th-educator"]} currentUserRole={currentUserRole}>
    <Nc5thEducatorClassroom />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-2nd-educator-math" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-educator"]} currentUserRole={currentUserRole}>
    <Nc2ndEducatorMath />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-2nd-educator-science" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-educator"]} currentUserRole={currentUserRole}>
    <Nc2ndEducatorScience />
  </PrivateRoute>}/>

  <Route path="/educator/nc/nc-2nd-educator-socialstudies" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-educator"]} currentUserRole={currentUserRole}>
    <Nc2ndEducatorSocialStudies />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-2nd-educator-other" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-educator"]} currentUserRole={currentUserRole}>
    <Nc2ndEducatorOther />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-3rd-educator-math" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-educator"]} currentUserRole={currentUserRole}>
    <Nc3rdEducatorMath />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-3rd-educator-science" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-educator"]} currentUserRole={currentUserRole}>
    <Nc3rdEducatorScience />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-3rd-educator-socialstudies" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-educator"]} currentUserRole={currentUserRole}>
    <Nc3rdEducatorSocialStudies />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-3rd-educator-other" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-educator"]} currentUserRole={currentUserRole}>
    <Nc3rdEducatorOther />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-4th-educator-math" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-4th-educator"]} currentUserRole={currentUserRole}>
    <Nc4thEducatorMath />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-4th-educator-science" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-4th-educator"]} currentUserRole={currentUserRole}>
    <Nc4thEducatorScience />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-4th-educator-socialstudies" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-4th-educator"]} currentUserRole={currentUserRole}>
    <Nc4thEducatorSocialStudies />
  </PrivateRoute>}/>

<Route path="/educator/nc/nc-4th-educator-other" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-4th-educator"]} currentUserRole={currentUserRole}>
    <Nc4thEducatorOther />
  </PrivateRoute>}/>


        <Route path="/educator/nc/nc-5th-educator-math" 
       element={<PrivateRoute allowedRoles={["administrator", "nc-5th-educator"]} currentUserRole={currentUserRole}>
      <Nc5thEducatorMath /></PrivateRoute>}/>
      <Route path="/educator/nc/nc-5th-educator-science" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-5th-educator"]} currentUserRole={currentUserRole}>
    <Nc5thEducatorScience />
  </PrivateRoute>}/>
<Route path="/educator/nc/nc-5th-educator-socialstudies" 
  element={<PrivateRoute allowedRoles={["administrator", "nc-5th-educator"]} currentUserRole={currentUserRole}>
    <Nc5thEducatorSocialStudies />
  </PrivateRoute>}/>
        <Route path="/educator/nc/nc-5th-educator-other"
          element={<PrivateRoute allowedRoles={["administrator", "nc-5th-educator"]} currentUserRole={currentUserRole}>
              <Nc5thEducatorOther /></PrivateRoute>}/>
              <Route path="/educator/classroom1st"
          element={<PrivateRoute allowedRoles={["administrator", "nc-1st-educator"]} currentUserRole={currentUserRole}>
              <Classroom1st /></PrivateRoute>}/>
              <Route path="/educator/classroom2nd"
          element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-educator"]} currentUserRole={currentUserRole}>
              <Classroom2nd /></PrivateRoute>}/>
              <Route path="/educator/classroom3rd"
          element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-educator"]} currentUserRole={currentUserRole}>
              <Classroom3rd /></PrivateRoute>}/>  
              <Route path="/educator/classroom4th"
          element={<PrivateRoute allowedRoles={["administrator", "nc-4th-educator"]} currentUserRole={currentUserRole}>
              <Classroom4th /></PrivateRoute>}/>    
              <Route path="/educator/classroom5th"
          element={<PrivateRoute allowedRoles={["administrator", "nc-5th-educator"]} currentUserRole={currentUserRole}>
              <Classroom5th /></PrivateRoute>}/>
              <Route path="/educator/va-1st-educator-socialstudies"
          element={<PrivateRoute allowedRoles={["administrator", "va-1st-educator"]} currentUserRole={currentUserRole}>
              <Va1stEducatorSocialStudies /></PrivateRoute>}/>
              <Route path="/educator/va-2nd-educator-socialstudies" 
  element={<PrivateRoute allowedRoles={["administrator", "va-2nd-educator"]} currentUserRole={currentUserRole}>
    <Va2ndEducatorSocialStudies />
  </PrivateRoute>}/>

<Route path="/educator/va-3rd-educator-socialstudies" 
  element={<PrivateRoute allowedRoles={["administrator", "va-3rd-educator"]} currentUserRole={currentUserRole}>
    <Va3rdEducatorSocialStudies />
  </PrivateRoute>}/>

<Route path="/educator/va-4th-educator-socialstudies" 
  element={<PrivateRoute allowedRoles={["administrator", "va-4th-educator"]} currentUserRole={currentUserRole}>
    <Va4thEducatorSocialStudies />
  </PrivateRoute>}/>

<Route path="/educator/va-5th-educator-socialstudies" 
  element={<PrivateRoute allowedRoles={["administrator", "va-5th-educator"]} currentUserRole={currentUserRole}>
    <Va5thEducatorSocialStudies />
  </PrivateRoute>}/>

  {/* Georgia Educator Routes */}
<Route path="/educator/ga/ga-1st-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ga-1st-educator"]} currentUserRole={currentUserRole}><Ga1stEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/ga/ga-2nd-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ga-2nd-educator"]} currentUserRole={currentUserRole}><Ga2ndEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/ga/ga-3rd-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ga-3rd-educator"]} currentUserRole={currentUserRole}><Ga3rdEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/ga/ga-4th-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ga-4th-educator"]} currentUserRole={currentUserRole}><Ga4thEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/ga/ga-5th-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ga-5th-educator"]} currentUserRole={currentUserRole}><Ga5thEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/ga/ga-1st-educator-science" element={<PrivateRoute allowedRoles={["administrator", "ga-1st-educator"]} currentUserRole={currentUserRole}><Ga1stEducatorScience /></PrivateRoute>} />
<Route path="/educator/ga/ga-2nd-educator-science" element={<PrivateRoute allowedRoles={["administrator", "ga-2nd-educator"]} currentUserRole={currentUserRole}><Ga2ndEducatorScience /></PrivateRoute>} />
<Route path="/educator/ga/ga-3rd-educator-science" element={<PrivateRoute allowedRoles={["administrator", "ga-3rd-educator"]} currentUserRole={currentUserRole}><Ga3rdEducatorScience /></PrivateRoute>} />
<Route path="/educator/ga/ga-4th-educator-science" element={<PrivateRoute allowedRoles={["administrator", "ga-4th-educator"]} currentUserRole={currentUserRole}><Ga4thEducatorScience /></PrivateRoute>} />
<Route path="/educator/ga/ga-5th-educator-science" element={<PrivateRoute allowedRoles={["administrator", "ga-5th-educator"]} currentUserRole={currentUserRole}><Ga5thEducatorScience /></PrivateRoute>} />
<Route path="/educator/ga/ga-1st-educator-math" element={<PrivateRoute allowedRoles={["administrator", "ga-1st-educator"]} currentUserRole={currentUserRole}><Ga1stEducatorMath /></PrivateRoute>} />
<Route path="/educator/ga/ga-2nd-educator-math" element={<PrivateRoute allowedRoles={["administrator", "ga-2nd-educator"]} currentUserRole={currentUserRole}><Ga2ndEducatorMath /></PrivateRoute>} />
<Route path="/educator/ga/ga-3rd-educator-math" element={<PrivateRoute allowedRoles={["administrator", "ga-3rd-educator"]} currentUserRole={currentUserRole}><Ga3rdEducatorMath /></PrivateRoute>} />
<Route path="/educator/ga/ga-4th-educator-math" element={<PrivateRoute allowedRoles={["administrator", "ga-4th-educator"]} currentUserRole={currentUserRole}><Ga4thEducatorMath /></PrivateRoute>} />
<Route path="/educator/ga/ga-5th-educator-math" element={<PrivateRoute allowedRoles={["administrator", "ga-5th-educator"]} currentUserRole={currentUserRole}><Ga5thEducatorMath /></PrivateRoute>} />
<Route path="/educator/ga/ga-1st-educator-other" element={<PrivateRoute allowedRoles={["administrator", "ga-1st-educator"]} currentUserRole={currentUserRole}><Ga1stEducatorOther /></PrivateRoute>} />
<Route path="/educator/ga/ga-2nd-educator-other" element={<PrivateRoute allowedRoles={["administrator", "ga-2nd-educator"]} currentUserRole={currentUserRole}><Ga2ndEducatorOther /></PrivateRoute>} />
<Route path="/educator/ga/ga-3rd-educator-other" element={<PrivateRoute allowedRoles={["administrator", "ga-3rd-educator"]} currentUserRole={currentUserRole}><Ga3rdEducatorOther /></PrivateRoute>} />
<Route path="/educator/ga/ga-4th-educator-other" element={<PrivateRoute allowedRoles={["administrator", "ga-4th-educator"]} currentUserRole={currentUserRole}><Ga4thEducatorOther /></PrivateRoute>} />
<Route path="/educator/ga/ga-5th-educator-other" element={<PrivateRoute allowedRoles={["administrator", "ga-5th-educator"]} currentUserRole={currentUserRole}><Ga5thEducatorOther /></PrivateRoute>} />
<Route path="/educator/ga/ga-5th-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "ga-5th-educator"]} currentUserRole={currentUserRole}><Ga5thEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/ga/ga-4th-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "ga-4th-educator"]} currentUserRole={currentUserRole}><Ga4thEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/ga/ga-3rd-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "ga-3rd-educator"]} currentUserRole={currentUserRole}><Ga3rdEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/ga/ga-2nd-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "ga-2nd-educator"]} currentUserRole={currentUserRole}><Ga2ndEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/ga/ga-1st-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "ga-1st-educator"]} currentUserRole={currentUserRole}><Ga1stEducatorClassroom /></PrivateRoute>} />


{/* North Carolina Student Routes */}
<Route path="/student/nc-1st-student-math" element={<PrivateRoute allowedRoles={["administrator", "nc-1st-student"]} currentUserRole={currentUserRole}><Nc1stStudentMath /></PrivateRoute>} />
<Route path="/student/nc-1st-student-science" element={<PrivateRoute allowedRoles={["administrator", "nc-1st-student"]} currentUserRole={currentUserRole}><Nc1stStudentScience /></PrivateRoute>} />
<Route path="/student/nc-1st-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "nc-1st-student"]} currentUserRole={currentUserRole}><Nc1stStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/nc-1st-student-other" element={<PrivateRoute allowedRoles={["administrator", "nc-1st-student"]} currentUserRole={currentUserRole}><Nc1stStudentOther /></PrivateRoute>} />
<Route path="/student/nc-2nd-student-math" element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-student"]} currentUserRole={currentUserRole}><Nc2ndStudentMath /></PrivateRoute>} />
<Route path="/student/nc-2nd-student-science" element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-student"]} currentUserRole={currentUserRole}><Nc2ndStudentScience /></PrivateRoute>} />
<Route path="/student/nc-2nd-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-student"]} currentUserRole={currentUserRole}><Nc2ndStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/nc-2nd-student-other" element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-student"]} currentUserRole={currentUserRole}><Nc2ndStudentOther /></PrivateRoute>} />
<Route path="/student/nc-3rd-student-math" element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-student"]} currentUserRole={currentUserRole}><Nc3rdStudentMath /></PrivateRoute>} />
<Route path="/student/nc-3rd-student-science" element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-student"]} currentUserRole={currentUserRole}><Nc3rdStudentScience /></PrivateRoute>} />
<Route path="/student/nc-3rd-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-student"]} currentUserRole={currentUserRole}><Nc3rdStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/nc-3rd-student-other" element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-student"]} currentUserRole={currentUserRole}><Nc3rdStudentOther /></PrivateRoute>} />
<Route path="/student/nc-4th-student-math" element={<PrivateRoute allowedRoles={["administrator", "nc-4th-student"]} currentUserRole={currentUserRole}><Nc4thStudentMath /></PrivateRoute>} />
<Route path="/student/nc-4th-student-science" element={<PrivateRoute allowedRoles={["administrator", "nc-4th-student"]} currentUserRole={currentUserRole}><Nc4thStudentScience /></PrivateRoute>} />
<Route path="/student/nc-4th-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "nc-4th-student"]} currentUserRole={currentUserRole}><Nc4thStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/nc-4th-student-other" element={<PrivateRoute allowedRoles={["administrator", "nc-4th-student"]} currentUserRole={currentUserRole}><Nc4thStudentOther /></PrivateRoute>} />
<Route path="/student/nc-5th-student-math" element={<PrivateRoute allowedRoles={["administrator", "nc-5th-student"]} currentUserRole={currentUserRole}><Nc5thStudentMath /></PrivateRoute>} />
<Route path="/student/nc-5th-student-science" element={<PrivateRoute allowedRoles={["administrator", "nc-5th-student"]} currentUserRole={currentUserRole}><Nc5thStudentScience /></PrivateRoute>} />
<Route path="/student/nc-5th-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "nc-5th-student"]} currentUserRole={currentUserRole}><Nc5thStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/nc-5th-student-other" element={<PrivateRoute allowedRoles={["administrator", "nc-5th-student"]} currentUserRole={currentUserRole}><Nc5thStudentOther /></PrivateRoute>} />
<Route path="/pages/adminclassroom" element={<PrivateRoute allowedRoles={["administrator"]} currentUserRole={currentUserRole}><AdminClassroom /></PrivateRoute>} />


        {/* VA Student Pages Routes */}
        <Route path="/student/va/va-1st-student-math" element={<PrivateRoute allowedRoles={["administrator", "va-1st-student"]} currentUserRole={currentUserRole}><Va1stStudentMath /></PrivateRoute>} />
<Route path="/student/va/va-1st-student-science" element={<PrivateRoute allowedRoles={["administrator", "va-1st-student"]} currentUserRole={currentUserRole}><Va1stStudentScience /></PrivateRoute>} />
<Route path="/student/va/va-1st-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "va-1st-student"]} currentUserRole={currentUserRole}><Va1stStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/va/va-1st-student-other" element={<PrivateRoute allowedRoles={["administrator", "va-1st-student"]} currentUserRole={currentUserRole}><Va1stStudentOther /></PrivateRoute>} />
<Route path="/student/va/va-2nd-student-math" element={<PrivateRoute allowedRoles={["administrator", "va-2nd-student"]} currentUserRole={currentUserRole}><Va2ndStudentMath /></PrivateRoute>} />
<Route path="/student/va/va-2nd-student-science" element={<PrivateRoute allowedRoles={["administrator", "va-2nd-student"]} currentUserRole={currentUserRole}><Va2ndStudentScience /></PrivateRoute>} />
<Route path="/student/va/va-2nd-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "va-2nd-student"]} currentUserRole={currentUserRole}><Va2ndStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/va/va-2nd-student-other" element={<PrivateRoute allowedRoles={["administrator", "va-2nd-student"]} currentUserRole={currentUserRole}><Va2ndStudentOther /></PrivateRoute>} />
<Route path="/student/va/va-3rd-student-math" element={<PrivateRoute allowedRoles={["administrator", "va-3rd-student"]} currentUserRole={currentUserRole}><Va3rdStudentMath /></PrivateRoute>} />
<Route path="/student/va/va-3rd-student-science" element={<PrivateRoute allowedRoles={["administrator", "va-3rd-student"]} currentUserRole={currentUserRole}><Va3rdStudentScience /></PrivateRoute>} />
<Route path="/student/va/va-3rd-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "va-3rd-student"]} currentUserRole={currentUserRole}><Va3rdStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/va/va-3rd-student-other" element={<PrivateRoute allowedRoles={["administrator", "va-3rd-student"]} currentUserRole={currentUserRole}><Va3rdStudentOther /></PrivateRoute>} />
<Route path="/student/va/va-4th-student-math" element={<PrivateRoute allowedRoles={["administrator", "va-4th-student"]} currentUserRole={currentUserRole}><Va4thStudentMath /></PrivateRoute>} />
<Route path="/student/va/va-4th-student-science" element={<PrivateRoute allowedRoles={["administrator", "va-4th-student"]} currentUserRole={currentUserRole}><Va4thStudentScience /></PrivateRoute>} />
<Route path="/student/va/va-4th-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "va-4th-student"]} currentUserRole={currentUserRole}><Va4thStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/va/va-4th-student-other" element={<PrivateRoute allowedRoles={["administrator", "va-4th-student"]} currentUserRole={currentUserRole}><Va4thStudentOther /></PrivateRoute>} />
<Route path="/student/va/va-5th-student-math" element={<PrivateRoute allowedRoles={["administrator", "va-5th-student"]} currentUserRole={currentUserRole}><Va5thStudentMath /></PrivateRoute>} />
<Route path="/student/va/va-5th-student-science" element={<PrivateRoute allowedRoles={["administrator", "va-5th-student"]} currentUserRole={currentUserRole}><Va5thStudentScience /></PrivateRoute>} />
<Route path="/student/va/va-5th-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "va-5th-student"]} currentUserRole={currentUserRole}><Va5thStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/va/va-5th-student-other" element={<PrivateRoute allowedRoles={["administrator", "va-5th-student"]} currentUserRole={currentUserRole}><Va5thStudentOther /></PrivateRoute>} />

{/* VA Educator Pages Routes */}
<Route path="/educator/va/va-1st-educator-math" element={<PrivateRoute allowedRoles={["administrator", "va-1st-educator"]} currentUserRole={currentUserRole}><Va1stEducatorMath /></PrivateRoute>} />
<Route path="/educator/va/va-1st-educator-science" element={<PrivateRoute allowedRoles={["administrator", "va-1st-educator"]} currentUserRole={currentUserRole}><Va1stEducatorScience /></PrivateRoute>} />
<Route path="/educator/va/va-1st-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "va-1st-educator"]} currentUserRole={currentUserRole}><Va1stEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/va/va-1st-educator-other" element={<PrivateRoute allowedRoles={["administrator", "va-1st-educator"]} currentUserRole={currentUserRole}><Va1stEducatorOther /></PrivateRoute>} />
<Route path="/educator/va/va-2nd-educator-math" element={<PrivateRoute allowedRoles={["administrator", "va-2nd-educator"]} currentUserRole={currentUserRole}><Va2ndEducatorMath /></PrivateRoute>} />
<Route path="/educator/va/va-2nd-educator-science" element={<PrivateRoute allowedRoles={["administrator", "va-2nd-educator"]} currentUserRole={currentUserRole}><Va2ndEducatorScience /></PrivateRoute>} />
<Route path="/educator/va/va-2nd-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "va-2nd-educator"]} currentUserRole={currentUserRole}><Va2ndEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/va/va-2nd-educator-other" element={<PrivateRoute allowedRoles={["administrator", "va-2nd-educator"]} currentUserRole={currentUserRole}><Va2ndEducatorOther /></PrivateRoute>} />
<Route path="/educator/va/va-3rd-educator-math" element={<PrivateRoute allowedRoles={["administrator", "va-3rd-educator"]} currentUserRole={currentUserRole}><Va3rdEducatorMath /></PrivateRoute>} />
<Route path="/educator/va/va-3rd-educator-science" element={<PrivateRoute allowedRoles={["administrator", "va-3rd-educator"]} currentUserRole={currentUserRole}><Va3rdEducatorScience /></PrivateRoute>} />
<Route path="/educator/va/va-3rd-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "va-3rd-educator"]} currentUserRole={currentUserRole}><Va3rdEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/va/va-3rd-educator-other" element={<PrivateRoute allowedRoles={["administrator", "va-3rd-educator"]} currentUserRole={currentUserRole}><Va3rdEducatorOther /></PrivateRoute>} />
<Route path="/educator/va/va-4th-educator-math" element={<PrivateRoute allowedRoles={["administrator", "va-4th-educator"]} currentUserRole={currentUserRole}><Va4thEducatorMath /></PrivateRoute>} />
<Route path="/educator/va/va-4th-educator-science" element={<PrivateRoute allowedRoles={["administrator", "va-4th-educator"]} currentUserRole={currentUserRole}><Va4thEducatorScience /></PrivateRoute>} />
<Route path="/educator/va/va-4th-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "va-4th-educator"]} currentUserRole={currentUserRole}><Va4thEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/va/va-4th-educator-other" element={<PrivateRoute allowedRoles={["administrator", "va-4th-educator"]} currentUserRole={currentUserRole}><Va4thEducatorOther /></PrivateRoute>} />
<Route path="/educator/va/va-5th-educator-math" element={<PrivateRoute allowedRoles={["administrator", "va-5th-educator"]} currentUserRole={currentUserRole}><Va5thEducatorMath /></PrivateRoute>} />
<Route path="/educator/va/va-5th-educator-science" element={<PrivateRoute allowedRoles={["administrator", "va-5th-educator"]} currentUserRole={currentUserRole}><Va5thEducatorScience /></PrivateRoute>} />
<Route path="/educator/va/va-5th-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "va-5th-educator"]} currentUserRole={currentUserRole}><Va5thEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/va/va-5th-educator-other" element={<PrivateRoute allowedRoles={["administrator", "va-5th-educator"]} currentUserRole={currentUserRole}><Va5thEducatorOther /></PrivateRoute>} />
<Route path="/educator/va/va-5th-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "va-5th-educator"]} currentUserRole={currentUserRole}><Va5thEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/va/va-4th-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "va-4th-educator"]} currentUserRole={currentUserRole}><Va4thEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/va/va-3rd-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "va-3rd-educator"]} currentUserRole={currentUserRole}><Va3rdEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/va/va-2nd-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "va-2nd-educator"]} currentUserRole={currentUserRole}><Va2ndEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/va/va-1st-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "va-1st-educator"]} currentUserRole={currentUserRole}><Va1stEducatorClassroom /></PrivateRoute>} />


        {/* Dynamic Classroom Route */}
        <Route path="/educator/:email-classroom"
          element={<PrivateRoute allowedRoles={["administrator", "nc-1st-educator", "nc-2nd-educator", "nc-3rd-educator", "nc-4th-educator", "nc-5th-educator"]} currentUserRole={currentUserRole}>
              <DynamicClassroom /></PrivateRoute>}/>

 {/* Route for AdminTools combination here */}

<Route path="/student/nc/nc-1st-student-math" element={<PrivateRoute allowedRoles={["administrator", "nc-1st-student"]} currentUserRole={currentUserRole}><Nc1stStudentMath /></PrivateRoute>} />
<Route path="/student/nc/nc-1st-student-science" element={<PrivateRoute allowedRoles={["administrator", "nc-1st-student"]} currentUserRole={currentUserRole}><Nc1stStudentScience /></PrivateRoute>} />
<Route path="/student/nc/nc-1st-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "nc-1st-student"]} currentUserRole={currentUserRole}><Nc1stStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/nc/nc-1st-student-other" element={<PrivateRoute allowedRoles={["administrator", "nc-1st-student"]} currentUserRole={currentUserRole}><Nc1stStudentOther /></PrivateRoute>} />
<Route path="/student/nc/nc-2nd-student-math" element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-student"]} currentUserRole={currentUserRole}><Nc2ndStudentMath /></PrivateRoute>} />
<Route path="/student/nc/nc-2nd-student-science" element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-student"]} currentUserRole={currentUserRole}><Nc2ndStudentScience /></PrivateRoute>} />
<Route path="/student/nc/nc-2nd-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-student"]} currentUserRole={currentUserRole}><Nc2ndStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/nc/nc-2nd-student-other" element={<PrivateRoute allowedRoles={["administrator", "nc-2nd-student"]} currentUserRole={currentUserRole}><Nc2ndStudentOther /></PrivateRoute>} />
<Route path="/student/nc/nc-3rd-student-math" element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-student"]} currentUserRole={currentUserRole}><Nc3rdStudentMath /></PrivateRoute>} />
<Route path="/student/nc/nc-3rd-student-science" element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-student"]} currentUserRole={currentUserRole}><Nc3rdStudentScience /></PrivateRoute>} />
<Route path="/student/nc/nc-3rd-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-student"]} currentUserRole={currentUserRole}><Nc3rdStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/nc/nc-3rd-student-other" element={<PrivateRoute allowedRoles={["administrator", "nc-3rd-student"]} currentUserRole={currentUserRole}><Nc3rdStudentOther /></PrivateRoute>} />
<Route path="/student/nc/nc-4th-student-math" element={<PrivateRoute allowedRoles={["administrator", "nc-4th-student"]} currentUserRole={currentUserRole}><Nc4thStudentMath /></PrivateRoute>} />
<Route path="/student/nc/nc-4th-student-science" element={<PrivateRoute allowedRoles={["administrator", "nc-4th-student"]} currentUserRole={currentUserRole}><Nc4thStudentScience /></PrivateRoute>} />
<Route path="/student/nc/nc-4th-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "nc-4th-student"]} currentUserRole={currentUserRole}><Nc4thStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/nc/nc-4th-student-other" element={<PrivateRoute allowedRoles={["administrator", "nc-4th-student"]} currentUserRole={currentUserRole}><Nc4thStudentOther /></PrivateRoute>} />
<Route path="/student/nc/nc-5th-student-math" element={<PrivateRoute allowedRoles={["administrator", "nc-5th-student"]} currentUserRole={currentUserRole}><Nc5thStudentMath /></PrivateRoute>} />
<Route path="/student/nc/nc-5th-student-science" element={<PrivateRoute allowedRoles={["administrator", "nc-5th-student"]} currentUserRole={currentUserRole}><Nc5thStudentScience /></PrivateRoute>} />
<Route path="/student/nc/nc-5th-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "nc-5th-student"]} currentUserRole={currentUserRole}><Nc5thStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/nc/nc-5th-student-other" element={<PrivateRoute allowedRoles={["administrator", "nc-5th-student"]} currentUserRole={currentUserRole}><Nc5thStudentOther /></PrivateRoute>} />

              <Route path="/educator/ga/ga-1st-educator-socialstudies" 
element={<PrivateRoute allowedRoles={["administrator", "ga-1st-educator"]} currentUserRole={currentUserRole}>
              <Ga1stEducatorSocialStudies /></PrivateRoute>}/>
              <Route path="/educator/ga/ga-2nd-educator-socialstudies" 
element={<PrivateRoute allowedRoles={["administrator", "ga-2nd-educator"]} currentUserRole={currentUserRole}>
              <Ga2ndEducatorSocialStudies /></PrivateRoute>}/>
              <Route path="/educator/ga/ga-3rd-educator-socialstudies" 
element={<PrivateRoute allowedRoles={["administrator", "ga-3rd-educator"]} currentUserRole={currentUserRole}>
              <Ga3rdEducatorSocialStudies /></PrivateRoute>}/>
              <Route path="/educator/ga/ga-4th-educator-socialstudies" 
element={<PrivateRoute allowedRoles={["administrator", "ga-4th-educator"]} currentUserRole={currentUserRole}>
              <Ga4thEducatorSocialStudies /></PrivateRoute>}/>
              <Route path="/educator/ga/ga-5th-educator-socialstudies" 
element={<PrivateRoute allowedRoles={["administrator", "ga-5th-educator"]} currentUserRole={currentUserRole}>
              <Ga5thEducatorSocialStudies /></PrivateRoute>}/>
              


{/* California Educator Routes */}
<Route path="/educator/ca/ca-1st-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ca-1st-educator"]} currentUserRole={currentUserRole}><Ca1stEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/ca/ca-2nd-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ca-2nd-educator"]} currentUserRole={currentUserRole}><Ca2ndEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/ca/ca-3rd-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ca-3rd-educator"]} currentUserRole={currentUserRole}><Ca3rdEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/ca/ca-4th-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ca-4th-educator"]} currentUserRole={currentUserRole}><Ca4thEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/ca/ca-5th-educator-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ca-5th-educator"]} currentUserRole={currentUserRole}><Ca5thEducatorSocialStudies /></PrivateRoute>} />
<Route path="/educator/ca/ca-1st-educator-science" element={<PrivateRoute allowedRoles={["administrator", "ca-1st-educator"]} currentUserRole={currentUserRole}><Ca1stEducatorScience /></PrivateRoute>} />
<Route path="/educator/ca/ca-2nd-educator-science" element={<PrivateRoute allowedRoles={["administrator", "ca-2nd-educator"]} currentUserRole={currentUserRole}><Ca2ndEducatorScience /></PrivateRoute>} />
<Route path="/educator/ca/ca-3rd-educator-science" element={<PrivateRoute allowedRoles={["administrator", "ca-3rd-educator"]} currentUserRole={currentUserRole}><Ca3rdEducatorScience /></PrivateRoute>} />
<Route path="/educator/ca/ca-4th-educator-science" element={<PrivateRoute allowedRoles={["administrator", "ca-4th-educator"]} currentUserRole={currentUserRole}><Ca4thEducatorScience /></PrivateRoute>} />
<Route path="/educator/ca/ca-5th-educator-science" element={<PrivateRoute allowedRoles={["administrator", "ca-5th-educator"]} currentUserRole={currentUserRole}><Ca5thEducatorScience /></PrivateRoute>} />
<Route path="/educator/ca/ca-1st-educator-math" element={<PrivateRoute allowedRoles={["administrator", "ca-1st-educator"]} currentUserRole={currentUserRole}><Ca1stEducatorMath /></PrivateRoute>} />
<Route path="/educator/ca/ca-2nd-educator-math" element={<PrivateRoute allowedRoles={["administrator", "ca-2nd-educator"]} currentUserRole={currentUserRole}><Ca2ndEducatorMath /></PrivateRoute>} />
<Route path="/educator/ca/ca-3rd-educator-math" element={<PrivateRoute allowedRoles={["administrator", "ca-3rd-educator"]} currentUserRole={currentUserRole}><Ca3rdEducatorMath /></PrivateRoute>} />
<Route path="/educator/ca/ca-4th-educator-math" element={<PrivateRoute allowedRoles={["administrator", "ca-4th-educator"]} currentUserRole={currentUserRole}><Ca4thEducatorMath /></PrivateRoute>} />
<Route path="/educator/ca/ca-5th-educator-math" element={<PrivateRoute allowedRoles={["administrator", "ca-5th-educator"]} currentUserRole={currentUserRole}><Ca5thEducatorMath /></PrivateRoute>} />
<Route path="/educator/ca/ca-1st-educator-other" element={<PrivateRoute allowedRoles={["administrator", "ca-1st-educator"]} currentUserRole={currentUserRole}><Ca1stEducatorOther /></PrivateRoute>} />
<Route path="/educator/ca/ca-2nd-educator-other" element={<PrivateRoute allowedRoles={["administrator", "ca-2nd-educator"]} currentUserRole={currentUserRole}><Ca2ndEducatorOther /></PrivateRoute>} />
<Route path="/educator/ca/ca-3rd-educator-other" element={<PrivateRoute allowedRoles={["administrator", "ca-3rd-educator"]} currentUserRole={currentUserRole}><Ca3rdEducatorOther /></PrivateRoute>} />
<Route path="/educator/ca/ca-4th-educator-other" element={<PrivateRoute allowedRoles={["administrator", "ca-4th-educator"]} currentUserRole={currentUserRole}><Ca4thEducatorOther /></PrivateRoute>} />
<Route path="/educator/ca/ca-5th-educator-other" element={<PrivateRoute allowedRoles={["administrator", "ca-5th-educator"]} currentUserRole={currentUserRole}><Ca5thEducatorOther /></PrivateRoute>} />
<Route path="/educator/ca/ca-1st-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "ca-1st-educator"]} currentUserRole={currentUserRole}><Ca1stEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/ca/ca-2nd-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "ca-2nd-educator"]} currentUserRole={currentUserRole}><Ca2ndEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/ca/ca-3rd-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "ca-3rd-educator"]} currentUserRole={currentUserRole}><Ca3rdEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/ca/ca-4th-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "ca-4th-educator"]} currentUserRole={currentUserRole}><Ca4thEducatorClassroom /></PrivateRoute>} />
<Route path="/educator/ca/ca-5th-educator-classroom" element={<PrivateRoute allowFree allowedRoles={["administrator", "ca-5th-educator"]} currentUserRole={currentUserRole}><Ca5thEducatorClassroom /></PrivateRoute>} />

{/* California Student Routes */}
<Route path="/student/ca/ca-1st-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ca-1st-student"]} currentUserRole={currentUserRole}><Ca1stStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/ca/ca-2nd-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ca-2nd-student"]} currentUserRole={currentUserRole}><Ca2ndStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/ca/ca-3rd-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ca-3rd-student"]} currentUserRole={currentUserRole}><Ca3rdStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/ca/ca-4th-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ca-4th-student"]} currentUserRole={currentUserRole}><Ca4thStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/ca/ca-5th-student-socialstudies" element={<PrivateRoute allowedRoles={["administrator", "ca-5th-student"]} currentUserRole={currentUserRole}><Ca5thStudentSocialStudies /></PrivateRoute>} />
<Route path="/student/ca/ca-1st-student-science" element={<PrivateRoute allowedRoles={["administrator", "ca-1st-student"]} currentUserRole={currentUserRole}><Ca1stStudentScience /></PrivateRoute>} />
<Route path="/student/ca/ca-2nd-student-science" element={<PrivateRoute allowedRoles={["administrator", "ca-2nd-student"]} currentUserRole={currentUserRole}><Ca2ndStudentScience /></PrivateRoute>} />
<Route path="/student/ca/ca-3rd-student-science" element={<PrivateRoute allowedRoles={["administrator", "ca-3rd-student"]} currentUserRole={currentUserRole}><Ca3rdStudentScience /></PrivateRoute>} />
<Route path="/student/ca/ca-4th-student-science" element={<PrivateRoute allowedRoles={["administrator", "ca-4th-student"]} currentUserRole={currentUserRole}><Ca4thStudentScience /></PrivateRoute>} />
<Route path="/student/ca/ca-5th-student-science" element={<PrivateRoute allowedRoles={["administrator", "ca-5th-student"]} currentUserRole={currentUserRole}><Ca5thStudentScience /></PrivateRoute>} />
<Route path="/student/ca/ca-1st-student-math" element={<PrivateRoute allowedRoles={["administrator", "ca-1st-student"]} currentUserRole={currentUserRole}><Ca1stStudentMath /></PrivateRoute>} />
<Route path="/student/ca/ca-2nd-student-math" element={<PrivateRoute allowedRoles={["administrator", "ca-2nd-student"]} currentUserRole={currentUserRole}><Ca2ndStudentMath /></PrivateRoute>} />
<Route path="/student/ca/ca-3rd-student-math" element={<PrivateRoute allowedRoles={["administrator", "ca-3rd-student"]} currentUserRole={currentUserRole}><Ca3rdStudentMath /></PrivateRoute>} />
<Route path="/student/ca/ca-4th-student-math" element={<PrivateRoute allowedRoles={["administrator", "ca-4th-student"]} currentUserRole={currentUserRole}><Ca4thStudentMath /></PrivateRoute>} />
<Route path="/student/ca/ca-5th-student-math" element={<PrivateRoute allowedRoles={["administrator", "ca-5th-student"]} currentUserRole={currentUserRole}><Ca5thStudentMath /></PrivateRoute>} />
<Route path="/student/ca/ca-1st-student-other" element={<PrivateRoute allowedRoles={["administrator", "ca-1st-student"]} currentUserRole={currentUserRole}><Ca1stStudentOther /></PrivateRoute>} />
<Route path="/student/ca/ca-2nd-student-other" element={<PrivateRoute allowedRoles={["administrator", "ca-2nd-student"]} currentUserRole={currentUserRole}><Ca2ndStudentOther /></PrivateRoute>} />
<Route path="/student/ca/ca-3rd-student-other" element={<PrivateRoute allowedRoles={["administrator", "ca-3rd-student"]} currentUserRole={currentUserRole}><Ca3rdStudentOther /></PrivateRoute>} />
<Route path="/student/ca/ca-4th-student-other" element={<PrivateRoute allowedRoles={["administrator", "ca-4th-student"]} currentUserRole={currentUserRole}><Ca4thStudentOther /></PrivateRoute>} />
<Route path="/student/ca/ca-5th-student-other" element={<PrivateRoute allowedRoles={["administrator", "ca-5th-student"]} currentUserRole={currentUserRole}><Ca5thStudentOther /></PrivateRoute>} />



      {/*Music, Video, Game Tools Routes*/}       

      <Route
  path="/video/:slug"
  element={
    <PrivateRoute
      allowedRoles={[adminRole, ...allStudentRoles, ...allEducatorRoles]}
      currentUserRole={currentUserRole}
    >
      <VideoTool />
    </PrivateRoute>
  }
/>

<Route
  path="/music/:slug"
  element={
    <PrivateRoute
      allowedRoles={[adminRole, ...allStudentRoles, ...allEducatorRoles]}
      currentUserRole={currentUserRole}
    >
      <MusicTool />
    </PrivateRoute>
  }
/>

<Route
  path="/game/:slug"
  element={
    <PrivateRoute
      allowedRoles={[adminRole, ...allStudentRoles, ...allEducatorRoles]}
      currentUserRole={currentUserRole}
    >
      <GameTool />
    </PrivateRoute>
  }
/>

<Route
  path="/utils/markProgress"
  element={
    <PrivateRoute
      allowedRoles={[adminRole, ...allStudentRoles, ...allEducatorRoles]}
      currentUserRole={currentUserRole}
    >
      <MarkProgress />
    </PrivateRoute>
  }
/>


        {/* Game Route */}
        <Route
  path="/games/:state/:grade/:subject/:view/:slug"
  element={
    <PrivateRoute
      allowFree
      allowedRoles={[
        "administrator",
        "admin",
        "Administrator",
        "Admin",
        ...allStudentRoles,
        ...allEducatorRoles,
      ]}
      currentUserRole={currentUserRole}
    >
      <UniversalQuizGame />
    </PrivateRoute>
  }
/>
        <Route path="/games/:subject/:slug" element={<UniversalQuizGame />} />
{/* SECURITY FIX: these two were completely unprotected. QuizUploader
    accepts a dropped JSON file and QuizManager writes straight to
    `quizzes/{slug}` — the GLOBAL question library. Anyone who guessed
    either URL could overwrite every quiz in the product from a browser.
    Admin-only now. Educators author their own questions at
    /educator/quiz/:subject/:slug, which writes to a scoped path. */}
<Route
  path="/upload-quiz"
  element={
    <PrivateRoute allowedRoles={["admin", "administrator"]}>
      <QuizUploader />
    </PrivateRoute>
  }
/>
<Route
  path="/manage-quizzes"
  element={
    <PrivateRoute allowedRoles={["admin", "administrator"]}>
      <QuizManager />
    </PrivateRoute>
  }
/>

{/* Legal pages. The footer has linked to both of these since it was
    written — neither route existed, so both links 404'd. Public on
    purpose: someone must be able to read the Terms before agreeing. */}
<Route path="/terms-of-service" element={<TermsOfService />} />
<Route path="/privacy-policy" element={<PrivacyPolicy />} />

{/* One classroom for every state and grade, replacing the 36 hardcoded
    pages under pages/educator/{state}/. Old paths still resolve via the
    redirect below so existing links and bookmarks keep working. */}
<Route
  path="/educator/:state/:grade/classroom"
  element={
    <PrivateRoute allowFree requireCapability="studentTracking">
      <EducatorClassroom />
    </PrivateRoute>
  }
/>
<Route
  path="/educator/classroom"
  element={
    <PrivateRoute allowFree requireCapability="studentTracking">
      <EducatorClassroom />
    </PrivateRoute>
  }
/>

{/* Back-compat for the 36 old hardcoded classroom URLs, e.g.
    /educator/va/va-3rd-educator-classroom. Those pages are replaced by the
    single EducatorClassroom above, but bookmarks, emails to teachers, and
    the navigate() call in DashboardEducator all still point at the old
    shape. This resolves them rather than 404ing, and the component reads
    state and grade off the params either way. */}
<Route
  path="/educator/:state/:legacySlug"
  element={
    <PrivateRoute allowFree requireCapability="studentTracking">
      <LegacyClassroomRedirect />
    </PrivateRoute>
  }
/>

{/* Educator-authored quiz questions. Scoped to the educator's own code —
    see pages/educator/EducatorQuizEditor.js. */}
<Route
  path="/educator/quiz/:subject/:slug"
  element={
    <PrivateRoute allowFree requireCapability="authoring">
      <EducatorQuizEditor />
    </PrivateRoute>
  }
/>

{/* Admin review queue for submitted educator questions. */}
<Route
  path="/admin/quiz-review"
  element={
    <PrivateRoute allowedRoles={["admin", "administrator"]}>
      <AdminQuizReview />
    </PrivateRoute>
  }
/>
{/* Shows student first names, so it requires a signed-in, email-verified
    account. allowFree because a child on a trial should still be able to see
    where they placed — the gate is "are you signed in", not "have you paid". */}
<Route
  path="/leaderboard/:slug"
  element={
    <PrivateRoute allowFree currentUserRole={currentUserRole}>
      <Leaderboard />
    </PrivateRoute>
  }
/>
{/* Every score for a topic, across every school. Same role list as
    /admin/quiz-review. */}
<Route
  path="/admin/leaderboards"
  element={
    <PrivateRoute
      allowedRoles={["admin", "administrator"]}
      currentUserRole={currentUserRole}
    >
      <AdminLeaderboards />
    </PrivateRoute>
  }
/>
<Route path="/treasure-map/:subject" element={<MapPage />} />
<Route path="/treasure-map/:subject/:slug?" element={<MapPage />} />


        {/* Dynamic Page Route */}
        <Route
          path="/pages/:view/:grade/:subject"
          element={
            <PageWrapper
              userRole={currentUserRole}
              pageParams={{
                state: ":state",
                grade: ":grade",
                subject: ":subject",
                view: ":view",
              }}
            >
              <DynamicPage />
            </PageWrapper>
          }
        />

        {/* Default Route.
            The final branch used to be <Navigate to="/unauthorized" />, which
            caught every signed-in account whose role was still "unpaid" —
            i.e. everyone between registering and the Stripe webhook promoting
            them. Landing on "Unauthorized" immediately after signing up reads
            as "you did something wrong". They go to a dashboard now; the
            dashboards limit their own content by access level, and
            PrivateRoute still guards everything that matters.

            currentUserRole is only used here for the admin check, which is
            safe because "administrator" is never a placeholder value.
            /dashboard then redirects educators onward — see Dashboard.js. */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              String(currentUserRole || "").includes("administrator") ||
              String(currentUserRole || "").includes("admin") ? (
                <Navigate to="/admin" replace />
              ) : String(currentUserRole || "").includes("educator") ? (
                <Navigate to="/educator/dashboard" replace />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            ) : (
              <PublicHome />
            )
          }
        />

        {/* Catch-All */}
        <Route path="*" element={<Navigate to="/login" />} /> {/* Redirect to Login by default */}
      </Routes>
    </CartProvider>
    </Router>
  );
}

export default App;

